define('common/customiseMoment',[
    'moment'
], function (moment) {
    
    moment.fn.isStartOfDay = function () {
        return this.clone().startOf('day').isSame(this);
    };

    return moment;
});

